import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { sntTranslate } from "src/app/support/translate";
import { Coat } from "../models/coat/coat";

@Injectable()
export class CoatBackend {
  private readonly http = inject(HttpClient);

  list(specie: string): Observable<Coat[]> {
    return this.http
      .get<Coat[]>(`${environment.snoots.api.directory}/coats/${specie}`)
      .pipe(map((coats: Coat[]) => coats.map(translateCoat)));
  }

  findOne(specie: string, coat: string): Observable<Coat | undefined> {
    return this.list(specie).pipe(
      map((list) => list.find((x) => x.key === coat)!),
      map((coat: Coat | undefined) => {
        if (!coat) {
          return undefined;
        }

        return translateCoat(coat);
      })
    );
  }
}

function translateCoat(coat: Coat): Coat {
  coat.value = sntTranslate(coat.value);
  return coat;
}
